import React from 'react'
import Dashboard from '../Dashboard';
import LogginUser from './LogginUser';


const CondicionLogin = () => {
    const estateuser = sessionStorage.getItem('_s');

return(
<>
{estateuser === 'success' ? <Dashboard /> :  <LogginUser />}
    </>)
}
export default CondicionLogin